import { getIndicatorStyles } from '@/components/features/layout/Header/Components/ActionButton';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const NotificationIndicator = ({ children }: { children: ReactNode }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  // const { unread } = useNotifications();

  const unread = false;

  return (
    <Box
      pos="relative"
      _after={{
        ...(isMobile && !!unread ? getIndicatorStyles(unread) : {}),
        zIndex: 'header.compactMenu',
      }}
    >
      {children}
    </Box>
  );
};
